import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import ProtectedRoute from './Components/ProtectedRoute'
import Login from './Pages/Login'
import Register from './Pages/Register'
import Dashboard from './Pages/Dashboard'
import SharedFile from './Pages/SharedFile'
import JavaCompiler from './Pages/JavaCompiler'
import PythonCompiler from './Pages/PythonCompiler'
import JsCompiler from './Pages/JSCompiler'
import CppComplier from './Pages/CppComplier'
import CComplier from './Pages/CCompiler'
import TextEditor from './Pages/TextEditor'
import NotFound from './Pages/NotFound'
import Sidebar from './Components/SideBar'
import './App.css'

const CompilerLayout = ({ children }) => {
  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-content">
        {children}
      </div>
    </div>
  )
}

// Component to redirect to dashboard if already logged in
const PublicRoute = ({ children }) => {
  const { user } = useAuth()
  return user ? <Navigate to="/dashboard" replace /> : children
}

const App = () => {
  return (
    <AuthProvider>

      <Routes>
        {/* Public Routes - Redirect to dashboard if already logged in */}
        <Route path="/login" element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } />
        <Route path="/register" element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        } />
        <Route path="/share/:token" element={<SharedFile />} />

        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />

        {/* Compiler Routes - Protected */}
        <Route path="/" element={
          <ProtectedRoute>
            <Navigate to="/dashboard" replace />
          </ProtectedRoute>
        } />
        <Route path="/compile/python" element={
          <ProtectedRoute>
            <CompilerLayout>
              <PythonCompiler />
            </CompilerLayout>
          </ProtectedRoute>
        } />
        <Route path="/compile/js" element={
          <ProtectedRoute>
            <CompilerLayout>
              <JsCompiler />
            </CompilerLayout>
          </ProtectedRoute>
        } />
        <Route path="/compile/java" element={
          <ProtectedRoute>
            <CompilerLayout>
              <JavaCompiler />
            </CompilerLayout>
          </ProtectedRoute>
        } />
        <Route path="/compile/cpp" element={
          <ProtectedRoute>
            <CompilerLayout>
              <CppComplier />
            </CompilerLayout>
          </ProtectedRoute>
        } />
        <Route path="/compile/c" element={
          <ProtectedRoute>
            <CompilerLayout>
              <CComplier />
            </CompilerLayout>
          </ProtectedRoute>
        } />
        <Route path="/editor/text" element={
          <ProtectedRoute>
            <CompilerLayout>
              <TextEditor />
            </CompilerLayout>
          </ProtectedRoute>
        } />

        {/* 404 Route */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
